import { createContext, useContext } from 'react';
import type { AppSettings } from './settings.types';
import { FALLBACK_SETTINGS } from './useSettings';

export const SettingsContext = createContext<AppSettings>(FALLBACK_SETTINGS);

/** ההגדרות בכל מקום בממשק, בלי קריאה נוספת לשרת. */
export function useSettings(): AppSettings {
  return useContext(SettingsContext);
}
